module.exports = __webpack_public_path__ + "static/media/Gorgeous.b6f436ea.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Gorgeous.eot
// module id = 2937
// module chunks = 70